import apiClient from './apiClient';

const getGuests = async () => {
    try {
        const response = await apiClient.get('/guests.php');
        return response.data;
    } catch (error) {
        console.error('Errore durante il recupero degli ospiti:', error);
        throw error;
    }
};

const getGuestById = async (id) => {
    try {
        const response = await apiClient.get(`/guests.php?id=${id}`);
        return response.data;
    } catch (error) {
        console.error(`Errore durante il recupero dell'ospite con ID ${id}:`, error);
        throw error;
    }
};

const createGuest = async (guestData) => {
    try {
        const response = await apiClient.post('/guests.php', guestData);
        const respData = response.data;
        if (respData && respData.id) {
            return respData;
        }
        // Il server remoto potrebbe restituire un formato vecchio senza id:
        // cerca l'ospite appena inserito tramite un GET di verifica.
        const allGuests = await getGuests();
        const match = (allGuests || [])
            .filter(g =>
                g.nome === guestData.nome &&
                g.cognome === guestData.cognome &&
                g.data_nascita === guestData.data_nascita
            )
            .sort((a, b) => Number(b.id) - Number(a.id))[0];
        if (match) return match;
        throw new Error('Inserimento fallito: ospite non trovato nel database dopo il salvataggio');
    } catch (error) {
        console.error('Errore durante la creazione di un nuovo ospite:', error);
        throw error;
    }
};

const updateGuest = async (id, guestData) => {
    try {
        const response = await apiClient.put(`/guests.php?id=${id}`, guestData);
        return response.data;
    } catch (error) {
        console.error(`Errore durante l'aggiornamento dell'ospite con ID ${id}:`, error);
        throw error;
    }
};

const deleteGuest = async (id) => {
    try {
        const response = await apiClient.delete(`/guests.php?id=${id}`);
        return response.data;
    } catch (error) {
        console.error(`Errore durante l'eliminazione dell'ospite con ID ${id}:`, error);
        throw error;
    }
};

const uploadPei = async (guestId, file) => {
    try {
        const formData = new FormData();
        formData.append('guest_id', guestId);
        formData.append('file', file);
        const response = await apiClient.post('/guests.php?action=upload_pei', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        console.error('Errore upload PEI:', error);
        throw error;
    }
};

const deletePei = async (guestId) => {
    try {
        const response = await apiClient.delete(`/guests.php?action=delete_pei&guest_id=${guestId}`);
        return response.data;
    } catch (error) {
        console.error('Errore delete PEI:', error);
        throw error;
    }
};

const fetchGuestAttachments = async (guestId) => {
    try {
        const response = await apiClient.get(`/guest_attachments.php?guest_id=${guestId}`);
        return response.data;
    } catch (error) {
        console.error('Errore fetch guest attachments:', error);
        throw error;
    }
};

const uploadGuestAttachments = async (guestId, files, category) => {
    try {
        const formData = new FormData();
        formData.append('guest_id', guestId);
        if (category) formData.append('category', category);
        for (let i = 0; i < files.length; i++) {
            formData.append('files[]', files[i]);
        }
        const response = await apiClient.post('/guest_attachments.php', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        console.error('Errore upload guest attachments:', error);
        throw error;
    }
};

const deleteGuestAttachment = async (id) => {
    try {
        const response = await apiClient.delete(`/guest_attachments.php?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Errore delete guest attachment:', error);
        throw error;
    }
};

const setGuestActive = async (id, isActive) => {
    try {
        const response = await apiClient.put(`/guests.php?id=${id}`, { is_active: isActive ? 1 : 0 });
        return response.data;
    } catch (error) {
        console.error(`Errore durante l'aggiornamento dello stato ospite ${id}:`, error);
        throw error;
    }
};

const updateGuestComment = async (id, comment) => {
    try {
        const payload = { revisione_pei_comment: comment };
        const response = await apiClient.put(`/guests.php?id=${id}`, payload);
        return response.data;
    } catch (error) {
        console.error(`Errore durante l'aggiornamento del commento PEI per l'ospite ${id}:`, error);
        throw error;
    }
};

export { getGuests, getGuestById, createGuest, updateGuest, deleteGuest, uploadPei, deletePei, fetchGuestAttachments, uploadGuestAttachments, deleteGuestAttachment, updateGuestComment, setGuestActive };
